export var FORM_CONTROL_TYPE_CHECKBOX = 'checkbox';
export var FORM_CONTROL_TYPE_DATE_RANGE = 'dateRange';
export var FORM_CONTROL_TYPE_RADIO = 'radio';
export var FORM_CONTROL_TYPE_RADIO_BUTTONS = 'radioButtons';
export var FORM_CONTROL_TYPE_SELECT = 'select';
export var FORM_CONTROL_TYPE_SWITCH = 'switch';
export var FORM_CONTROL_TYPE_TEXT = 'text';
export var FORM_CONTROL_TYPE_FIELDSET = 'fieldset';
export var FORM_CONTROL_TYPE_CUSTOM = 'custom';
export var FORM_CONTROL_TYPES = [FORM_CONTROL_TYPE_CHECKBOX, FORM_CONTROL_TYPE_DATE_RANGE, FORM_CONTROL_TYPE_RADIO, FORM_CONTROL_TYPE_RADIO_BUTTONS, FORM_CONTROL_TYPE_SELECT, FORM_CONTROL_TYPE_SWITCH, FORM_CONTROL_TYPE_TEXT, FORM_CONTROL_TYPE_FIELDSET, FORM_CONTROL_TYPE_CUSTOM];